// Chakra imports
import { Flex, Image, Text, useColorModeValue } from '@chakra-ui/react';
import cocorevLogo from 'assets/img/brand/cocorevLogo.png';

// Custom components
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
  const logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex alignItems="center" flexDirection="column" gap={5}>
      <Text fontSize={'30px'} fontWeight="800" color={logoColor}>
        <Image maxW="190px" src={cocorevLogo} />
      </Text>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
